/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import MaskedInput from 'react-text-mask';

import _ from 'lodash';

// import constants
import { TEXT_FIELD_CONST } from './Constants'

// import styles 
// import styles from './CustomTextField.css'; // common styles 
import CommonStyles from '../../CommonStyles.css';

// custom wrapper styles
const useStyles = makeStyles(theme => ({
  // base style of the TextField Component
  textField: {
    'label + &': {
      marginTop: theme.spacing(0.5),
    },
    '& .MuiInputBase-input': {
      // '&:focus': {
      //   backgroundColor: 'transparent',
      //   boxShadow: '#1976d2 0 0 2px 0px',
      //   border: '1px solid #1976d2',
      // },
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        backgroundColor: 'transparent',
        boxShadow: '#1976d2 0 0 2px 0px',
        border: '1px solid #1976d2',
      },
    },
  },
  // style with no border, used for display text only
  textFieldDisplayOnly: {
    'label + &': {
      marginTop: theme.spacing(-0.5),
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-input': {
      color: '#142A39',
    }
  }
}));

// render mask pattern text
// Function is outside of functional class,
// render will happen once and not on every change of state/props
const TextMaskCustom = (props) => {
  const { inputRef, mask, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={mask}
      guide={false}
      showMask
    />
  );
}

/** MaterialUI component - TextField
 * Using wrapper style and custom props / function
 * Use for Text / Number / Tel / wrapper mask 
 * Props /use 
    label - label annotation 
    mandatory - required property,
    size - materialUI defined sizes - 'medium'| 'small',
    variant -  materialUI defined variant,
    type - 'text' / number,
    placeholder,
    maxlength - max length for field validation,
    onChange - input on change fn,
    stateKey - key name reference to update the sate in component
    icon - as icon component ,
    validation - validation fn passed (return true / false),
    maskInput - pattern ,
    errorText - Error text on validation,
    helperText,
    iconCallback - on icon Click fn,
    disabled,
    value - use for default value,
    displayOnly - Text display without border (Vew only), need disabled to be true
    rows - display multiline, whe used as Text area
    validateForm - function callback to check / update component form state
 * */
const CustomTextField = props => {
  const classes = useStyles();
  const [error, setError] = useState(false);
  const [mandatoryError, setMandatoryError] = useState(false);
  const MANDATORY_TEXT = 'Required';
  const {
    label = '',
    mandatory = false,
    size = '',
    variant = TEXT_FIELD_CONST.VARIANT.OUTLINED,
    type = TEXT_FIELD_CONST.TYPE.TEXT,
    placeholder = '',
    maxlength,
    onChange,
    stateKey,
    icon,
    validation,
    maskInput = undefined,
    errorText = '',
    helperText = '',
    iconCallback,
    disabled = false,
    value = '',
    displayOnly = false,
    rows,
    validateForm,
  } = props;

  // validate maxlength defined/passed in Number type case
  const numberInputHandler = (e) => {
    e.preventDefault && e.preventDefault()
    const { value } = e.target;
    if (type === TEXT_FIELD_CONST.TYPE.NUMBER && maxlength !== undefined && value.length >= maxlength) {
      e.preventDefault && e.preventDefault()
      return;
    }
  }

  // callback set component's form state
  const componentValidate = (state) => {
    if (validateForm !== undefined) {
      validateForm(state)
    }
  }

  // onChange, check validation & passed onchange fn
  const onInputChange = e => {
    e.preventDefault && e.preventDefault();
    // if validation fn is passed, check and set error state of class 
    if (validation !== undefined) {
      const { value } = e.target;
      if (validation(e)) {
        setError(false)
        componentValidate(false)
      }
      else {
        setError(true)
        componentValidate(true)
      }
    }
    // if onChange fn is passed, check and send the event , stateKey
    if (onChange !== undefined) {
      onChange(e, stateKey)
    }
  }

  // add inputComponent if maskInput pattern is passed
  const fieldProps = maskInput !== undefined && {
    inputComponent: TextMaskCustom
  }

  // Display error / helper / required -text
  const msgTextDisplay = () => {
    let msgDisplay = '';
    if (error) {
      msgDisplay = errorText;
      componentValidate(true)
    } else if (mandatoryError) {
      msgDisplay = MANDATORY_TEXT;
      componentValidate(true)
    } else if (helperText) {
      msgDisplay = helperText;
    }
    return msgDisplay;
  }

  // check if value changed, do the validation
  // covers manual(Programmatically) state change, which are not input changes 
  useEffect(() => {
    // show if field is empty
    if (mandatory && (value === '' || value === null)) {
      setMandatoryError(true);
      componentValidate(true)
    } else if (mandatory && (value !== '' || value !== null)) {
      setMandatoryError(false);
      componentValidate(false)
    }

    // Validation
    if (validation !== undefined) {
      if (validation(value, true)) {
        setError(false)
        componentValidate(false)
      }
      else {
        setError(true)
        componentValidate(true)
      }
    }

  }, [value])

  return <React.Fragment>
    <InputLabel shrink >
      {label}
      {mandatory &&
        <label className={CommonStyles.asterisk}>&#x2a;
        </label>
      }
    </InputLabel>
    <TextField
      className={displayOnly ? classes.textFieldDisplayOnly : classes.textField}
      fullWidth={true}
      type={type}
      id={label}
      size={size}
      variant={variant}
      onChange={event => onInputChange(event)}
      required={mandatory}
      placeholder={placeholder}
      error={error || mandatoryError}
      helperText={msgTextDisplay()}
      value={value === null ? '' : value}
      onKeyPress={type === TEXT_FIELD_CONST.TYPE.NUMBER ? numberInputHandler : () => { }}
      disabled={disabled}
      multiline={rows !== undefined}
      rows={rows}
      inputProps={{
        maxLength: maxlength,
        mask: maskInput,
      }}
      InputProps={{
        ...fieldProps,
        endAdornment: icon && (
          <InputAdornment>
            <IconButton
              onClick={iconCallback}
              disabled={iconCallback === undefined}>
              {icon}
            </IconButton>
          </InputAdornment>
        ),
      }} />
  </React.Fragment>
    ;
}

export default CustomTextField;


// WEBPACK FOOTER //
// ./src/views/components/Common/FormMUIWrapperComponents/CustomTextField/CustomTextField.jsx